const REQUIRED = "Campo requerido";
const SIZE = "Tamanho da senha incorreto";
const INVALID_FORMAT = "Formato inválido";

export {
    REQUIRED,
    SIZE,
    INVALID_FORMAT
}